import { Injectable } from '@angular/core';
import { FilterService } from '../filter.service';
import { CacheService } from './cache.service';
import { SexFilter, DocumentTypeFilter } from '../../model/patient';
import { CountryFilter } from '../../model/geography/country-filter';
import { RelevancePatientFilter } from '../../model/patient/relevance-patient-filter';
import { ReferringPhysicianSpecialityFilter } from '../../model/referring-physician/referring-physician-speciality-filter';
import { RelevanceReferringPhysicianFilter } from '../../model/referring-physician/relevance-referring-physician-filter';
import { MedicalOrderScannType } from '../../model/medical-order-scann-type';
import { SectorFilter } from '../../model/sector-filter';
import { PhysicianFilter } from 'src/app/model/physician-Filter';
import { PracticeRegionFilter } from 'src/app/model/practice-region-filter';
import { PracticeFilter } from '../../model/practice/practice-filter';


@Injectable()
export class CacheFilterService {

  constructor(private filterService: FilterService
    , private cacheService: CacheService) { }

  private countryFilters: CountryFilter[];
  private sexFilters: SexFilter[];
  private documentTypeFilters: DocumentTypeFilter[];
  private relevancePatientFilters: RelevancePatientFilter[];
  private referringPhysicianSpecialityFilters: ReferringPhysicianSpecialityFilter[];
  private relevanceReferringPhysicianFilters: RelevanceReferringPhysicianFilter[];
  private medicalOrderScannTypes: MedicalOrderScannType[];
  private sectorFilters: SectorFilter[];
  private physicianFilters: PhysicianFilter[];
  private practiceRegionFilters: PracticeRegionFilter[];
  private practicesFilters: PracticeFilter[];


  async getPracticesFilters(): Promise<PracticeFilter[]> {
    if (!this.practicesFilters) {
      this.practicesFilters = await this.filterService.getPracticesFilters();
    }
    return this.practicesFilters;
  }

  async getPracticeRegionFilters(): Promise<PracticeRegionFilter[]> {
    if (!this.practiceRegionFilters) {
      this.practiceRegionFilters = await this.filterService.getPracticesRegionFilter();
    }
    return this.practiceRegionFilters;
  }

  async getPhysicianFilters(): Promise<PhysicianFilter[]> {
    if (!this.physicianFilters) {
      this.physicianFilters = await this.filterService.getPhysiciansFilter();
    }
    return this.physicianFilters;
  }

  async getSectorFilters(): Promise<SectorFilter[]> {
    if (!this.sectorFilters) {
      this.sectorFilters = await this.filterService.getSectorsFilter();
    }
    return this.sectorFilters;
  }

  async getMedicalOrderScannTypesFilter(): Promise<MedicalOrderScannType[]> {
    if (!this.medicalOrderScannTypes) {
      this.medicalOrderScannTypes = await this.filterService.getMedicalOrderScannTypesFilter();
    }
    return this.medicalOrderScannTypes;
  }

  async getRelevanceReferringPhysicianFilters(): Promise<RelevanceReferringPhysicianFilter[]> {
    if (!this.relevanceReferringPhysicianFilters) {
      this.relevanceReferringPhysicianFilters = await this.filterService.getRelevanceReferringPhysicianFilters();
    }
    return this.relevanceReferringPhysicianFilters;
  }

  async getReferringPhysicianSpecialityFilters(): Promise<ReferringPhysicianSpecialityFilter[]> {
    if (!this.referringPhysicianSpecialityFilters) {
      this.referringPhysicianSpecialityFilters = await this.filterService.getReferringPhysicianSpecialityFilters();
    }
    return this.referringPhysicianSpecialityFilters;
  }

  async getRelevancePatientFilters(): Promise<RelevancePatientFilter[]> {
    if (!this.relevancePatientFilters) {
      this.relevancePatientFilters = await this.filterService.getRelevancePatientFilters();
    }
    return this.relevancePatientFilters;
  }

  async getCountryFilters(): Promise<CountryFilter[]> {
    if (!this.countryFilters) {
      this.countryFilters = await this.filterService.getCountryFilters();
    }
    return this.countryFilters;
  }

  async getSexFilters(): Promise<SexFilter[]> {
    if (!this.sexFilters) {
      this.sexFilters = await this.filterService.getSexFilters();
    }
    return this.sexFilters;
  }

  async getDocumentTypeFilters(): Promise<DocumentTypeFilter[]> {
    if (!this.documentTypeFilters) {
      this.documentTypeFilters = await this.filterService.getDocumentTypeFilters();
    }
    return this.documentTypeFilters;
  }
}
